enum DuplicateStatus {
  DISMISSED = "dismissed",
  ERRORED = "errored",
  MERGED = "merged",
  ONGOING = "ongoing",
  OPEN = "open",
}

export default DuplicateStatus;
